export default __webpack_public_path__ + "static/media/co4.dad3216e.png";